module.exports = __webpack_public_path__ + "media/images/result_sets/circles/6r5n9r3n-f652233232298af752309cdc0b196f8a.svg";